# Поиск по сайту
class window.Pagination
  constructor: ->
    @curPage = 1 # текущая страница
    @paginationLink = $('.pagination-by-page__link')
    @initPagination()

  initPagination: ->
    @paginationLink.click ->
      setPage = $(this).data('page')

      if @curPage != setPage
        @curPage = setPage
        window.answersObject.curPage = @curPage;
        window.answersObject.AnswersAjaxExec()

  


// WEBPACK FOOTER //
// ./assets/javascripts/app/pagination.coffee